import React from "react";
import { Link } from "react-router-dom";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard-page">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <h2 className="admin-title">
        Admin Dashboard
      </h2>

      <p className="admin-subtitle">
        Karibu kwenye sehemu ya admin. Chagua shughuli unayotaka kufanya:
      </p>


      {/* =====================================================
          ADMIN TOOLS
      ===================================================== */}

      <div className="admin-tools-grid">

        <Link
          to="/admin/admin-securitywithdraw"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔐 Security Withdraw
          </button>
        </Link>


        <Link
          to="/admin/add-match"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ➕ Add Match
          </button>
        </Link>


        <Link
          to="/All-AddMatches-Filter"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ➕ AllAddMatchesFilter
          </button>
        </Link>


        <Link
          to="/admin-matchmanager"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🛠️ AdminDailyMatchManager
          </button>
        </Link>


        <Link
          to="/Adimn-View-Ended-Matches"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ViewEndedMatches
          </button>
        </Link>


        <Link
          to="/Admin-VistorDeposit"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            VistorDeposit
          </button>
        </Link>


        <Link
          to="/Admin-MonthlyBonus"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔺🍇 AdminMonthlyBonus
          </button>
        </Link>


        <Link
          to="/admin/bonus-member"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🎁 UserRoles
          </button>
        </Link>


        <Link
          to="/Admin-BonusManager"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🎁 Futa Bonus
          </button>
        </Link>


        <Link
          to="/Admin-TeamProfitSearch"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            Kagua usahii wa commission
          </button>
        </Link>


        <Link
          to="/Admin-Notifications"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔔 Admin Notifications
          </button>
        </Link>


        <Link
          to="/admin-transactions"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔄 Transactions
          </button>
        </Link>


        <Link
          to="/admin-bets-wrong-pay"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🚫❓ Admin IF Bets-WrongPay
          </button>
        </Link>


        <Link
          to="/admin-betspayoutlost"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ❌ Bets Payout Lost
          </button>
        </Link>


        <Link
          to="/admin-tafutagamesyauser"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            Tafutagamesyauser
          </button>
        </Link>


        <Link
          to="/Admin-Usdt-Transaction"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            AdmiUsdtTransaction
          </button>
        </Link>


        <Link
          to="/edit-match/1"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ✏️ Edit Match
          </button>
        </Link>


        <Link
          to="/admin-historiayadau"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            📜 Kagua Miamala ya watumiaji
          </button>
        </Link>


        <Link
          to="/admin-managenumbers"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔢 Manage Numbers
          </button>
        </Link>


        <Link
          to="/admin-commissions"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            👛 AdminCommissions
          </button>
        </Link>


        <Link
          to="/admin-betsrequest"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          ⚽⚽⚽⚽ Admin Bets Request AntScore
          </button>
        </Link>


        <Link
          to="/admin-commissionhistory"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            📊 Commission History
          </button>
        </Link>



        <Link
          to="/Admin-Copy-Trading-Request"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          💹AdminCopyTradingRequest
          </button>
        </Link>



      

        <Link
          to="/Admin-Add-Copy-Trading"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          💹AdminAddCopyTrading
          </button>
        </Link>

     


        <Link
          to="/admin-deletedwithdrawhistory"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🗑️ Deleted Deposit
          </button>
        </Link>


        <Link
          to="/Futa-Maombi-Ya-Uondoaji"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🧹 Futa Maombi
          </button>
        </Link>


        <Link
          to="/match-list"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            📋 Match List
          </button>
        </Link>


        <Link
          to="/admin-withdrawalpanel"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            💵 Withdrawal Panel
          </button>
        </Link>


        <Link
          to="/adminwithdrawal"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            💸 Withdraw
          </button>
        </Link>


        <Link
          to="/AdminSearchUser"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            💸 HackingPhone
          </button>
        </Link>
        <Link
          to="/adminadd-tabletennes"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          🏓TableTennes
          </button>
        </Link>
        <Link
          to="/admin-addtennis"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          🎾Admin AddTennis
          </button>
        </Link>

       
        <Link
          to="/Admin-BadilishaMudaWaMatches"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            👁️ BadilishaMudaWaMatches
          </button>
        </Link>


        <Link
          to="/admin/pending-withdrawals"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ⏳ PendingWithdraw
          </button>
        </Link>

        <Link
          to="/adminadd-basketball"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          🏀AdminAddHBasketball

          </button>
        </Link>

        <Link
          to="/adminadd-baseball"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          ⚾🧢 Adminaddbaseball

          </button>
        </Link>




        <Link
          to="/AdminOther-BetCorrectScore"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          🎾🏓🏀⚾🧢AdminOtherBetCorrectScore

          </button>
        </Link>




        <Link
          to="/AdminOther-BetAntScore"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          🎾🏓AdminOtherBetAntScore

          </button>
        </Link>



        
        
        <Link
          to="/adminadd-icehockey"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          ⛸️AdminAddIceHockey

          </button>
        </Link>


       
        <Link
          to="/Admin-Generation-Matches"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ⏳AdminGenerationMatches
          </button>
        </Link>


        <Link
          to="/AdminVolatility-ForexTransaction"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ⏳AdminVolatility-ForexTransaction
          </button>
        </Link>

        <Link
          to="/admin-volatility"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ⏳AdminTrackingVolatilityTrade
          </button>
        </Link>

       
        
       
        <Link
          to="/admin-usersearch"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🔍 User Search
          </button>
        </Link>


        <Link
          to="/Admin-AddFinalScore"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            🎧 AdminAddFinalScore
          </button>
        </Link>


        <Link
          to="/Admin-HackingMatches"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            👽 Admin-HackingMatches
          </button>
        </Link>


        <Link
          to="/admin-BetCorectScore"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            ⚖️ AdminBetCorrectScore
          </button>
        </Link>


        <Link
          to="/admin/admin-users"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            👥 Admin Users
          </button>
        </Link>


        <Link
          to="/admin-usersmember"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            👥 Users Member
          </button>
        </Link>

        <Link
          to="/Admin-Forex-Tracking"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          💹💹AdminForexTracking
          </button>
        </Link>


       
        <Link
          to="/admin-exchanges"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            AdminExchanges
          </button>
        </Link>


        <Link
          to="/postertemplate"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            PosterTemplate
          </button>
        </Link>


        <Link
          to="/admin-balance-control"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            AdminBalanceControl
          </button>
        </Link>


        <Link
          to="/admin-cheki-bonus"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            Kagua bonus
          </button>
        </Link>


        <Link
          to="/admin.futa.group"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            Futamagroup
          </button>
        </Link>


        <Link
          to="/Admin-UserBonus"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            AdminUserBonus
          </button>
        </Link>


        <Link
          to="/Admin-DuplicateMatches"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
            Futamatches zilizo jirudia
          </button>
        </Link>


        <Link
          to="/Admin-View-Withdra-wHistory"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
             Admin-View-WithdrawHistory
          </button>
        </Link>
        <Link
          to="/Admin-Ediot-Transaction"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          ❄️🌈 ❄️🌈AdminEdiotTransaction
          </button>
        </Link>
        <Link
          to="/admin/bet-history"
          className="admin-tool-link"
        >
          <button className="admin-tool-button">
          ❄️🌈❄️🌈AdminViewBetHistory
          </button>
        </Link>
     

      </div>

    </div>
  );
};

export default AdminDashboard;